import {TableColumn} from './TableColumn';
import {TableIndex} from './TableIndex';

export class Table {
autoIndex: boolean;
bu: string;
columns: TableColumn[];
domain: string;
indexes: TableIndex[];
name: string;
processCode: string;
stepCode: string;
vision: string;
withPath: boolean;
}

